// https://vuex.vuejs.org/guide/modules.html
import mutations from "./mutations.js";
import actions from "./actions.js";
import getters from "./getters.js";

const global = {
  state: {
    isApplicationLoading: false,
    componentLoadings: {},
    errors: []
  },
  getters,
  mutations,
  actions
};

export default global;
